import styled from 'styled-components';
import { EMAIL } from 'constants/messageMediums';
import { Card } from 'ui/cardV2';
import { CARD_BORDER_RADIUS } from 'ui/cardV2/constants';
import { borderRadius, colors, mediumShadow, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

import { MobilePreview } from './MobilePreview';

export const ResourcePreviewContainer = styled(Card).attrs({
  borderRadius: CARD_BORDER_RADIUS.XXL,
})`
  width: ${pxToRem(322)};
  ${mediumShadow}

  && {
    padding: ${spacing.threeQuarter};
  }
`;

export const EmptyTemplatePreviewContainer = styled(ResourcePreviewContainer)`
  &[data-medium=${EMAIL}] {
    width: ${pxToRem(630)};
  }
`;

export const EmailPreviewContainer = styled(ResourcePreviewContainer)`
  width: ${pxToRem(630)};

  && {
    padding-bottom: 0;
  }
`;

export const MobilePreviewContainer = styled(ResourcePreviewContainer)`
  height: ${pxToRem(184)};
`;

export const MobilePreviewContent = styled.div`
  background: ${colors.backgroundTertiary};
  overflow: hidden;
  width: 100%;
  height: 100%;
  border-radius: ${pxToRem(6)};
  display: flex;
  justify-content: center;
  padding: ${spacing.plusHalf} 0;
`;

export const StyledMobilePreview = styled(MobilePreview)`
  border: 2px solid ${colors.grey25};
  border-radius: ${borderRadius.xxl};
  background-color: ${colors.white};
`;
